class ESACustomBundle extends HTMLElement {
  constructor() {
    super();

    this.selectedItems = {};
  }

  connectedCallback() {
    this.cacheDom();
    this.bindEvents();

    this.setInitialBundle();
    this.handleSubscriptionToggle();
    this.updateBundleState();
  }

  cacheDom() {
    this.bundleCards = [...this.querySelectorAll('.esb__bundle-card')];
    this.flavourCards = [...this.querySelectorAll('.esb__flavour-card')];

    this.summary = this.querySelector('.esb__bundle-summary');
    this.atcButton = this.querySelector('.esb__bundle-atc');
    this.atcText = this.querySelector('.esb__bundle-atc-text');

    this.subtotalPrice = this.querySelector('.esb__bundle-subtotal-price');
    this.savingPrice = this.querySelector('.esb__bundle-savings-price');

    this.subscription = this.querySelector('.esb__subscription');
    this.subscriptionInput = this.querySelector('.esb__subscription-input');

    this.variantInput = this.querySelector('input[name="id"]');
    this.itemsInput = this.querySelector('input[name="properties[Items]"]');
    this.bundleDataInput = this.querySelector('input[name="properties[_esb_data]"]');
    this.bundleSkuInput = this.querySelector('input[name="properties[_esb_sku_data]"]');

    this.giftSelector = this.querySelector('.esb__gift-selector');
    this.errorEl = this.querySelector('.esb__bundle-error');
  }

  bindEvents() {
    this.bundleCards.forEach(card => {
      card.addEventListener('click', () => {
        this.selectBundle(card);
      });
    });

    this.flavourCards.forEach(card => {

      const plus = card.querySelector('.esb__qty-btn--plus');
      const minus = card.querySelector('.esb__qty-btn--minus');
      const input = card.querySelector('.esb__qty-input');

      plus?.addEventListener('click', () => {
        this.changeQty(card, 1);
      });

      minus?.addEventListener('click', () => {
        this.changeQty(card, -1);
      });

      input?.addEventListener('change', () => {
        this.validateQty(card);
      });
    });

    this.subscriptionInput?.addEventListener('change', () => {
      this.handleSubscriptionToggle();
    });

    this.atcButton?.addEventListener('click', e => {
      this.handleAddToCart(e);
    });
  }

  setInitialBundle() {

    const activeCard =
      this.querySelector('.esb__bundle-card--active') ||
      this.bundleCards[0];

    if (activeCard) {
      this.selectBundle(activeCard);
    }
  }

  selectBundle(card) {
    this.bundleCards.forEach(item => item.classList.remove('esb__bundle-card--active'));

    card.classList.add('esb__bundle-card--active');
    this.activeBundle = card;
    this.requiredItems = parseInt(card.dataset.maxLimit || 0);

    if (this.variantInput) this.variantInput.value = card.dataset.variantId;

    this.summary.dataset.requiredItems = this.requiredItems;

    this.resetFlavours();

    this.handleSubscriptionToggle();
    this.updateGiftState();
    this.updateBundleState();
    this.updateProductInputs();
    this.updateQtyButtons();
  }

  changeQty(card, delta) {

    const input = card.querySelector('.esb__qty-input');

    const controls = card.querySelector('.esb__qty-controls');

    let qty = parseInt(input.value || 0);

    const totalSelected = this.getTotalSelected();

    const maxLimit = parseInt(this.requiredItems || 0);

    if (delta > 0 && totalSelected >= maxLimit) {
      return;
    }

    qty += delta;

    if (qty < 0) {
      qty = 0;
    }

    input.value = qty;

    if (qty > 0) {
      controls.classList.add('esb__qty-enabled');
    } else {
      controls.classList.remove('esb__qty-enabled');
    }

    this.updateQtyButtons();
    this.updateBundleState();
    this.updateProductInputs();
  }

  validateQty(card) {

    const input =
      card.querySelector('.esb__qty-input');

    const controls =
      card.querySelector('.esb__qty-controls');

    let qty =
      parseInt(input.value || 0);

    if (qty < 0) {
      qty = 0;
    }

    input.value = qty;

    if (qty > 0) {
      controls.classList.add('esb__qty-enabled');
    } else {
      controls.classList.remove('esb__qty-enabled');
    }

    this.updateQtyButtons();
    this.updateBundleState();
  }

  getTotalSelected() {
    let total = 0;

    this.flavourCards.forEach(card => {
      total += parseInt(card.querySelector('.esb__qty-input').value || 0);
    });

    return total;
  }

  updateQtyButtons() {
    const totalSelected = this.getTotalSelected();
    const maxLimit = parseInt(this.requiredItems || 0);

    this.flavourCards.forEach(card => {
      const plus = card.querySelector('.esb__qty-btn--plus');
      if (!plus) return;

      plus.disabled = totalSelected >= maxLimit;
    });
  }

  updateGiftState() {
    if (!this.subscription) return;

    const unlockOptions = (this.subscription.dataset.unlockOptions || '').split(',').map(item => item.trim());
    const currentPack = this.activeBundle?.dataset.value || '';

    const unlocked = this.subscriptionInput.checked &&
      unlockOptions.some(option => option === currentPack);

    this.subscription.dataset.giftUnlocked = unlocked;

    if (this.giftSelector) {
      this.giftSelector.style.display = unlocked ? '' : 'none';
    }
  }

  updateBundleState() {
    const readableItems = [];
    const bundleData = [];
    const bundleSkuData = []

    this.flavourCards.forEach(card => {
      const qty = parseInt(card.querySelector('.esb__qty-input').value || 0);
      if (!qty) return;
      const variantId = card.dataset.variantId;
      const sku = card.dataset.sku;
      const title = card.dataset.title;
      readableItems.push(`${title} x${qty}`);
      bundleData.push(`${variantId}_${qty}`);
      bundleSkuData.push(`${sku}_${qty}`);
    });

    if (this.itemsInput) {
      this.itemsInput.value = readableItems.join(', ');
    }

    if (this.bundleDataInput) {
      this.bundleDataInput.value = bundleData.join(',');
    }
    if (this.bundleSkuInput) {
      this.bundleSkuInput.value = bundleSkuData.join(',');
    }

    const selected = this.getTotalSelected();
    const required = parseInt(this.requiredItems || 0);
    const complete = selected === required;

    if (complete) {
      this.atcButton.dataset.disabled = 'false';
      this.atcText.textContent = this.summary.dataset.completeText;
    } else {
      const remaining = Math.max(required - selected, 0);
      this.atcButton.dataset.disabled = 'true';
      this.atcText.textContent = this.summary.dataset.incompleteText.replace('||count||', remaining);
    }
  }

  updateSummaryPrices() {

    if (!this.activeBundle) return;

    const isSubscription = this.subscriptionInput.checked;

    const subtotal = isSubscription ? this.activeBundle.dataset.subPrice : this.activeBundle.dataset.otPrice;

    const savePrice = isSubscription ? this.activeBundle.dataset.subSavePrice : this.activeBundle.dataset.otSavePrice;

    const hasSaving = savePrice && !savePrice.includes('0,0') && !savePrice.includes('0.0');

    if (this.subtotalPrice) this.subtotalPrice.textContent = subtotal;

    const savingWrapper = this.querySelector('.esb__bundle-savings');

    if (savingWrapper) {
      savingWrapper.style.display = hasSaving ? '' : 'none';
    }

    if (this.savingPrice && hasSaving) {
      this.savingPrice.textContent = savePrice;
    }
  }

  handleSubscriptionToggle() {

    const isSubscription = this.subscriptionInput.checked;

    this.bundleCards.forEach(card => {

      const comparePrice = card.dataset.comparePrice;
      const bundlePrice = isSubscription ? card.dataset.subPrice : card.dataset.otPrice;
      const eachPrice = isSubscription ? card.dataset.subEachPrice : card.dataset.otEachPrice;
      const discount = isSubscription ? card.dataset.subDiscount : card.dataset.otDiscount;
      const savePrice = isSubscription ? card.dataset.subSavePrice : card.dataset.otSavePrice;

      const currentPriceEl = card.querySelector('.esb__bundle-current-price');
      const comparePriceEl = card.querySelector('.esb__bundle-compare-price');
      const eachPriceEl = card.querySelector('.esb__bundle-each-price');
      const badgeEl = card.querySelector('.esb__bundle-badge');

      const hasSaving = savePrice && !savePrice.includes('0,00') && !savePrice.includes('0.00');

      const hasDiscount = discount && discount.toLowerCase() !== '0% off';

      if(currentPriceEl) currentPriceEl.textContent = bundlePrice;

      if(eachPriceEl) eachPriceEl.textContent = eachPrice;

      if (badgeEl) {
        badgeEl.textContent = discount;
        badgeEl.style.display = hasDiscount ? '' : 'none';
      }

      if (comparePriceEl) {
        comparePriceEl.textContent = comparePrice;
        comparePriceEl.style.display = hasSaving ? '' : 'none';
      }
    });

    this.updateSummaryPrices();
    this.updateGiftState();
    this.updateProductInputs();
  }
  
  updateProductInputs() {
    if (!this.activeBundle) return;

    if (this.variantInput) {
      this.variantInput.value = this.activeBundle.dataset.variantId;
    }

    const sellingPlanInput = this.querySelector('input[name="selling_plan"]');
    if (!sellingPlanInput) return;

    sellingPlanInput.value = this.subscriptionInput.checked && this.activeBundle.dataset.sellingPlan ? this.activeBundle.dataset.sellingPlan : '';
  }

  resetFlavours() {

    this.flavourCards.forEach(card => {
      const input = card.querySelector('.esb__qty-input');
      const controls = card.querySelector('.esb__qty-controls');

      if (input) {
        input.value = 0;
      }

      controls?.classList.remove('esb__qty-enabled');
      const plus = card.querySelector('.esb__qty-btn--plus');

      if (plus) {
        plus.disabled = false;
      }
    });

    if (this.itemsInput) {
      this.itemsInput.value = '';
    }

    if (this.bundleDataInput) {
      this.bundleDataInput.value = '';
    }

    if (this.atcButton) {
      this.atcButton.dataset.disabled = 'true';
    }

    if (this.atcText && this.summary?.dataset?.incompleteText) {
      this.atcText.textContent = this.summary.dataset.incompleteText.replace('||count||', this.requiredItems);
    }
  }

  showError(message) {
    if (!this.errorEl) return;
    clearTimeout(this.errorTimeout);
    this.errorEl.textContent = message;
    this.errorEl.hidden = false;
    this.errorTimeout = setTimeout(() => {
      this.errorEl.hidden = true;
    }, 4000);
  }

  scrollToFlavours() {
    const flavours = this.querySelector('.esb__flavours');
    if (!flavours) return;

    flavours.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }

  handleAddToCart(e) {
    e.preventDefault();
    const selected = this.getTotalSelected();
    const required = parseInt(this.requiredItems || 0);
    if (selected < required) {
      this.scrollToFlavours();
      return;
    }

    if (selected > required) {
      this.showError(`Maximum ${required} flavours allowed.`);
      return;
    }

    this.submitBundle();
  }

  async submitBundle() {
    try {
      this.loading = true;
      this.atcButton.classList.add('loading-atc');
      const properties = {
        Items: this.itemsInput.value,
        _esb_data: this.bundleDataInput.value,
        _esb_sku_data: this.bundleSkuInput.value
      };
      const bundleItem = {
        id: Number(this.variantInput.value),
        quantity: 1,
        properties
      };

      if (this.subscriptionInput.checked && this.activeBundle?.dataset?.sellingPlan) {
        bundleItem.selling_plan = Number(this.activeBundle.dataset.sellingPlan);
      }

      const payload = {
        items: [bundleItem]
      };

      const giftVariantId = this.getSelectedGiftVariantId();

      if (this.isGiftUnlocked() && giftVariantId) {
        payload.items.push({
          id: Number(giftVariantId),
          quantity: 1,
          parent_id: this.variantInput.value,
          properties: {
            _free_gift: 'true'
          }
        });
      }

      const addResponse = await fetch('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest'}, body: JSON.stringify(payload)});
      const addData = await addResponse.json();

      if (!addResponse.ok) {
        throw new Error(
          addData.description ||
          addData.message ||
          'Unable to add bundle.'
        );
      }

      const sectionsResponse = await fetch(`${window.location.pathname}?sections=cart-items,cart-footer,cart-item-count`);

      const sectionsText = await sectionsResponse.text();
      const sections = JSON.parse(sectionsText);

      document.body.dispatchEvent(new CustomEvent('shapes:cart:afteradditem', {
        bubbles: true,
        detail: {
          response: {
            ...addData,
            sections
          },
          sourceId: 'esa-custom-bundle'
        }
      }));
    } catch (error) {
      this.showError(error?.message || 'Unable to add bundle.');
    } finally {
      this.loading = false;
      this.atcButton.classList.remove('loading-atc');
    }
  }

  getSelectedGiftVariantId() {
    const gift = this.querySelector('.esb__gift-radio:checked');
    return gift?.value || null;
  }

  isGiftUnlocked() {
    return (this.subscriptionInput.checked && this.subscription?.dataset.giftUnlocked === 'true' && this.giftSelector);
  }
}

customElements.define( 'esa-custom-bundle', ESACustomBundle);